import React from 'react';

import * as Page from 'components/page';
import { useEffectOnce } from 'react-use';
import { useParams } from 'react-router';

import { SubscriptionBack } from '../components';

export const SubscriptionSuccessSDNone = props => {
    const { eventId } = useParams();

    const { vars, getEventById } = props.useSubscription;
    const { eventById } = vars;

    useEffectOnce(() => {
        getEventById(eventId);
    });

    return (
        <Page.Page name="SubscriptionSuccessSDNone">
            <Page.Title>{props.t('Subscription.title')}</Page.Title>
            <Page.Descr>{props.t('SubscriptionSuccess.success')}</Page.Descr>

            <SubscriptionBack events={eventById} />
        </Page.Page>
    );
};
export default SubscriptionSuccessSDNone;
